module.exports = "https://cdn.redage.net/src/views/player/jobselector/assets/images/padlock-unlock.svg";